module.exports = __webpack_public_path__ + "img/Unidad16-6.5ab6309c.png";